// Module
var code = " <h4>Filter dates</h4> <div class=\"level\" id=\"optionFilterDatesJournals\">...loading...</div> <div class=\"level\" id=\"optionFilterDatesRecords\">...loading...</div> ";
// Exports
export default code;